import {useNavigate} from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';


export default function AnalyticsContainerReports( props ){
    //console.debug("RTS Break AnalyticsContainerReports");

    const history = useNavigate();


    return(
        <>
        <Box>
            <Grid container>
                <Grid item xs={6} sm={5} lg={4}>
                    <Button
                        onClick={(event) => {history("/REPLoadsShippedLast30DaysPage");}}
                    >
                        <Typography>Reels Shipped Last 30 Days</Typography>
                    </Button>                            
                </Grid>
                <Grid item xs={6} sm={7} lg={8}>
                    <Typography>Shows a list of all reels sold and shipped to your organization.</Typography>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={6} sm={5} lg={4}>
                    <Button
                        onClick={(event) => {history("/REPLoadsReturnedLast30DaysPage");}}
                    >
                        <Typography>Reels Returned Last 30 Days</Typography>
                    </Button>                            
                </Grid>
                <Grid item xs={6} sm={7} lg={8}>
                    <Typography>Shows a list of all reels returned by your organization.</Typography>
                </Grid>
            </Grid>                                    
            <Grid container>
                <Grid item xs={6} sm={5} lg={4}>
                    <Button
                        onClick={(event) => {history("/REPLoadsDueDetailPage");}}
                    >
                        <Typography>Reels Due Details</Typography>
                    </Button>                            
                </Grid>
                <Grid item xs={6} sm={7} lg={8}>
                    <Typography>Shows all reels based on due date.</Typography>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={6} sm={5} lg={4}>
                    <Button
                        onClick={(event) => {history("/REPLoadsAwaitingReturnPage");}}
                    >
                        <Typography>Reels Awaiting Return</Typography>
                    </Button>                            
                </Grid>
                <Grid item xs={6} sm={7} lg={8}>
                    <Typography>Shows all reels on submitted Pickup Requests.</Typography>
                </Grid>
            </Grid> 
            <Grid container>
                <Grid item xs={6} sm={5} lg={4}>
                    <Button
                        onClick={(event) => {history("/REPLoadsBatteryLevelPage");}}
                    >
                        <Typography>Reel Tracker Battery Levels</Typography>
                    </Button>                            
                </Grid>
                <Grid item xs={6} sm={7} lg={8}>
                    <Typography>Shows the tracker battery level orderd by amount left.</Typography>
                </Grid>
            </Grid> 
            <Grid container>
                <Grid item xs={6} sm={5} lg={4}>
                    <Button
                        onClick={(event) => {history("/REPLoadsProductRemainsDetailPage");}}
                    >
                        <Typography>Reel Product Remains Details</Typography>
                    </Button>                            
                </Grid>
                <Grid item xs={6} sm={7} lg={8}>
                    <Typography>Shows the details about the amount of product left on a reel.</Typography>
                </Grid>
            </Grid>                                                                               
            <Grid container>
                <Grid item xs={6} sm={5} lg={4}>
                    <Button
                        onClick={(event) => {history("/REPPullDetailsPage");}}
                    >
                        <Typography>Pull Details</Typography>
                    </Button>                            
                </Grid>
                <Grid item xs={6} sm={7} lg={8}>
                    <Typography>Shows the details about pulls performed.</Typography>
                </Grid>
            </Grid>          </Box>
        </>   
    );
}
